var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[ 'image-ratio' ].concat( _vm.className )},[_c('img',_vm._b({attrs:{"src":_vm.src}},'img',_vm.attrs,false))])}
var staticRenderFns = []

export { render, staticRenderFns }